import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc.js'
import timezone from 'dayjs/plugin/timezone.js'
dayjs.extend(utc);
dayjs.extend(timezone);
import demoParams from '../../__test__/demoParams.js';
const { demoMode, demoShortPostedId, demoLongPostedId } = demoParams;

/**
 * Returns an array of Posted Schedules.
 * @param {*} listPostedSchedules
 */
const generateListPostedScheduleArray = (listPostedSchedules) => {

  dayjs.tz.setDefault('America/New_York');
  // NOTE on handling annual calendar change in 1&2-day posted schedules:
  // incrementing 1-9 days from the current date  automatically handles the case where the year crossover occurs mid-week
  return [
    { name: 'postedDayOneId', id: demoMode ? demoShortPostedId : listPostedSchedules.postedDayOneId, startDate: dayjs().format('M/D/YYYY'), scheduleFormat: 1 },
    { name: 'postedDayTwoId', id: listPostedSchedules.postedDayTwoId, startDate: dayjs().add(1, 'day').format('M/D/YYYY'), scheduleFormat: 1 },
    { name: 'postedDayThreeId', id: listPostedSchedules.postedDayThreeId, startDate: dayjs().add(2, 'day').format('M/D/YYYY'), scheduleFormat: 1 },
    { name: 'postedDayFourId', id: listPostedSchedules.postedDayFourId, startDate: dayjs().add(3, 'day').format('M/D/YYYY'), scheduleFormat: 1 },
    { name: 'postedDayFiveId', id: listPostedSchedules.postedDayFiveId, startDate: dayjs().add(4, 'day').format('M/D/YYYY'), scheduleFormat: 1 },
    { name: 'postedDaySixId', id: listPostedSchedules.postedDaySixId, startDate: dayjs().add(5, 'day').format('M/D/YYYY'), scheduleFormat: 1 },
    { name: 'postedDaySevenId', id: listPostedSchedules.postedDaySevenId, startDate: dayjs().add(6, 'day').format('M/D/YYYY'), scheduleFormat: 1 },
    { name: 'postedDayEightId', id: listPostedSchedules.postedDayEightId, startDate: dayjs().add(7, 'day').format('M/D/YYYY'), scheduleFormat: 1 },
    { name: 'postedTwoDaysToday', id: demoMode ? demoShortPostedId : listPostedSchedules.postedTwoDaysToday, startDate: dayjs().format('M/D/YYYY'), scheduleFormat: 2 },
    { name: 'postedTwoDaysTomorrow', id: listPostedSchedules.postedTwoDaysTomorrow, startDate: dayjs().add(1, 'day').format('M/D/YYYY'), scheduleFormat: 2 },
    { name: 'savedMd7', id: demoMode ? demoLongPostedId : listPostedSchedules.postedSevenDayId, startDate: listPostedSchedules.savedMd7, scheduleFormat: 7 },
    { name: 'savedMd9', id: demoMode ? demoLongPostedId : listPostedSchedules.postedNineDayId, startDate: listPostedSchedules.savedMd9, scheduleFormat: 9 },
  ];
}

export default generateListPostedScheduleArray;
